import * as z from "zod/v4";

export const getContextualSetupStatus = {
  name: "getContextualSetupStatus" as const,
  input: z.object({}),
  output: z.object({
    enabled: z.boolean(),
    ctxDomain: z.string().nullable(),
    cloudflareHostnameId: z.string().nullable(),
    isCtxMerchant: z.boolean(),
    storeUrl: z.string(),
    onboardingCompleted: z.boolean(),
  }),
};
